import { Upload } from "src/types";
import { Conta } from "../contas/contas/types";
import { Cidade } from "../geral/RegioesDataTable/types";

export interface Pedido {
    id?: number;
    codigo_venda: string;
    situacao: string;
    potencia: number;
    valor: number;
    valor_servico: number;
    valor_pagamento: number;
    valor_desconto?: number;
    estabelecimento_id?: number;
    estabelecimento_modificado_id: number | null;
    justificativa: string | null;
    bloqueio: string | null;
    created_at: string | null;
    updated_at: string | null;
    usuario_id: number;
    codigo_pedido: string | null;
    data_integracao: string | null;
    distribuidor?: Contato;
    revenda?: Contato;
    cliente?: Contato;
    forma_pagamento?: FormaPagamento;
    ev?: Contato;
    componentes: Componente[];
    modificados: Modificado[];
    data_previsao_faturamento?: string | null;
    data_pagamento?: string | null;
    notificacoes?: Notificacao[];
    etapa_pedido?: string;
    nota_fiscal_conta_ordem?: NFContaOrdem
}

export interface PagamentoNotificacao {
    id: number;
    observacao: string;
    codigo_venda: string;
    data_envio: string;
}

export type NFContaOrdem = {
    id?: number | null;
    pedido_id?: number | null;
    url?: string | null;
    created_at?: string | null;
    updated_at?: string | null;
}

export interface FormaPagamento {
    id: number;
    nome: string;
}

export interface Contato {
    id?: number;
    tipo_conta_id: number;
    cnpj_cpf: null | string;
    nome: string;
    fantasia: null | string;
    telefone: string;
    email: string;
    cidade_id: null;
    cidade_integracao: string;
    created_at: string | null;
    updated_at: null;
}

export interface Componente {
    componente?: ComponentePedido;
    componente_id: number;
    quantidade: number;
    valor_unitario: number;
    valor: number;
    saldo: number;
    data_saldo: string | null;
    checked?: boolean;
    novo?: boolean;
    situacao: string;
}

export interface Notificacao {
    observacao: string;
    bloqueio: boolean;
}

export interface Modificado {
    componente?: ComponentePedido;
    componente_id: number;
    componente_substituido_id: number | null;
    situacao: SITUACAO_COMPONENTE;
    quantidade: number;
    valor_unitario: number;
    valor: number;
    saldo: number;
    data_saldo: string | null;
    created_at?: string | null;
    updated_at?: string | null;
    usuario_id?: number;
}

export interface ComponentePedido {
    id: number;
    altura: number;
    categoria_componentes_id: number;
    comprimento: number;
    considerar_calculo: boolean;
    created_at: Date;
    dados_integracao: any;
    descricao: string;
    descricao_comercial: string;
    exibir_listagem: boolean;
    fabricante_id: number | null;
    largura: number;
    modelo: string;
    nome: string;
    nome_comercial: string;
    peso: number;
    segmento: string;
    tempo_garantia: number;
    tempo_garantia_unidade: string;
    updated_at: Date;
    venda: string;
}


export interface ComponenteCalculo {
    componente_id: number;
    quantidade: number;
    valor: number;
    categoria_componentes_id: number;
    peso: number;
    altura?: number;
    largura?: number;
    potencia?: number;
}

export interface DadosCalculoPedido {
    componentes: ComponenteCalculo[];
    modificados: ComponenteCalculo[];
}

export interface PedidoCalculoResponse {
    componentes: ComponentesPedidoCalculo;
    modificados: ComponentesPedidoCalculo;
}

export interface ComponentesPedidoCalculo {
    area_total: number;
    peso_gerador: number;
    peso_telhado: number;
    valor: number;
    potencia_gerador: number;
}


export enum SITUACAO {
    PENDENTES = 'pendente',
    REGISTRADO = 'registrado',
    ANALISE = 'analise',
    INTEGRADO = 'integrado',
    EXPIRADO = 'expirado',
}

export enum SITUACAO_VALIDACAO {
    OK = "ok",
    SALDO = 'saldo',
    ESTABELECIMENTO = "estabelecimento",
    GERAL = "geral",
}

export enum SITUACAO_NOTIFICACAO {
    NAO = "nao",
    SIM = "sim",
    BLOQUEIO = "bloqueio",
}

export enum SITUACAO_COMPONENTE {
    SALDO = 'saldo',
    ORIGINAL = 'original',
    SUBSTITUIDO = 'substituido',
    NOVO = 'novo',
    ALTERADO = 'alterado',
    EXCLUIDO = 'excluido',
}

export enum SITUACAO_EMAIL {
    AMBOS = "",
    ENVIADO = "enviado",
    NAO_ENVIADO = "nao_enviado",
}

export enum SITUACAO_PEDIDO {
    AMBOS = "",
    PEDIDO = "pedido",
    NAO_PEDIDO = "nao_pedido",
}

export const DEFAULT_PEDIDO: Pedido = {
    id: undefined,
    codigo_venda: "",
    situacao: SITUACAO.REGISTRADO,
    potencia: 0,
    valor: 0,
    valor_servico: 0,
    valor_pagamento: 0,
    distribuidor: undefined,
    revenda: undefined,
    cliente: undefined,
    ev: undefined,
    estabelecimento_id: undefined,
    estabelecimento_modificado_id: null,
    modificados: [],
    componentes: [],
    justificativa: null,
    bloqueio: null,
    created_at: null,
    updated_at: null,
    data_integracao: null,
    codigo_pedido: null,
    usuario_id: 0,
}

export const LISTA_ESTABELECIMENTO = [
    {
        text: "1007",
        value: "1007",
    },
    {
        text: "1005",
        value: "1005",
    },
];

export const LISTA_SITUACAO_NOTIFICACAO = [
    {
        text: "Sem notificação",
        value: SITUACAO_NOTIFICACAO.NAO,
    },
    {
        text: "Com notificação",
        value: SITUACAO_NOTIFICACAO.SIM,
    },
    {
        text: "Notificação Bloqueio",
        value: SITUACAO_NOTIFICACAO.BLOQUEIO,
    },
];

export const LISTA_SITUACAO_VALIDACAO = [
    {
        text: "OK",
        value: SITUACAO_VALIDACAO.OK,
    },
    {
        text: "Saldo",
        value: SITUACAO_VALIDACAO.SALDO,
    },
    {
        text: "Estabelecimento",
        value: SITUACAO_VALIDACAO.ESTABELECIMENTO,
    },
    {
        text: "Bloqueio Geral",
        value: SITUACAO_VALIDACAO.GERAL,
    },
];

export const LISTA_SITUACAO = [
    {
        text: "Pendentes",
        value: SITUACAO.PENDENTES,
    },
    {
        text: "Em Análise",
        value: SITUACAO.ANALISE,
    },
    {
        text: "Integrados",
        value: SITUACAO.INTEGRADO,
    },
];

export const LISTA_SITUACAO_PROJETOS_VERTICAIS = [
    {
        text: "Registrados",
        value: SITUACAO.REGISTRADO,
    },
    {
        text: "Expirados",
        value: "expirado",
    },
    {
        text: "Finalizados",
        value: "finalizado",
    },
    {
        text: "Cancelados",
        value: "cancelado",
    }
];

export const LISTA_SITUACAO_COMPONENTE = [
    {
        text: "Novo",
        value: SITUACAO_COMPONENTE.NOVO,
    },
    {
        text: "Substituído",
        value: SITUACAO_COMPONENTE.SUBSTITUIDO,
    },
    {
        text: "Saldo",
        value: SITUACAO_COMPONENTE.SALDO,
    }
]

export const LISTA_SITUACAO_EMAIL = [
    {
        text: "Enviado",
        value: SITUACAO_EMAIL.ENVIADO,
    },
    {
        text: "Não enviado",
        value: SITUACAO_EMAIL.NAO_ENVIADO,
    }
]

export const LISTA_SITUACAO_PEDIDO = [
    {
        text: "Com pedido",
        value: SITUACAO_PEDIDO.PEDIDO,
    },
    {
        text: "Sem pedido",
        value: SITUACAO_PEDIDO.NAO_PEDIDO,
    }
]

export interface Verticais {
    id?: number;
    proposta_anexada?: boolean
    auto_comissao: boolean;
    titulo: string;
    codigo_venda?: string | null;
    cliente_proposta: string;
    email_proposta: string;
    cpf_proposta?: string;
    cpf_cnpj_proposta?: string;
    situacao: string;
    prioridade?: string;
    segmento?: string;
    potencia?: number;
    valor?: number;
    valor_servico?: number;
    valor_servico_pis_cofins?: number;
    valor_comissao_revenda?: number;
    cidade_id?: number;
    cidade_nome?: string;
    cidade?: Cidade;
    uf?: string;
    nota_fiscal_triangular: boolean;
    distribuidor_id?: number | null;
    fantasia_distribuidor?: string;
    revenda_id?: number | null;
    fantasia_revenda?: string;
    ev_id?: number | null;
    analista_id?: number | null;
    ev_nome?: string;
    analista_nome?: string;
    data_integracao?: string | null;
    created_at?: string | null;
    updated_at?: string | null;
    ev?: Conta
    analista?: Conta
    revenda?: Conta
    distribuidor?: Conta
    servico: ProjetoServico
    user_guilted_id?: null | number
    componentes?: ComponenteProjeto[] | null
    anexos?: Anexo[] | null
    uploads?: Upload[] | null;
    area_total?: number;
    peso_gerador?: number;
    peso_telhado?: number;
    potencia_gerador?: number;
    potencia_inversor?: number;
    observacao_sorps?: string;
    observacao?: string;
    consideracao?: string;
    disposicoes?: Disposicao[] | null;
    percentual_comissao_distribuidor: number;
    percentual_comissao_revenda: number;
    descontos?: Desconto[];
    etapa_venda?: string;
    data_etapa_venda?: string | null;
    solicitacao?: ProjetoSolicitacoes;
    revisoes?: ProjetosRevisoes[];
    "@proposta_atualizada"?: boolean;
    data_expiracao?: string | Date;
    data_cancelamento?: string | Date;
    data_solicitacao_pausa?: string | Date;
    justificativa_valor_servico?: string;
}

export type ProjetosRevisoes = {
    id?: number | null;
    projeto_id?: number | null;
    descricao?: string;
    data_revisao?: string | null;
}

export type ProjetoSolicitacoes = {
    id?: number | null;
    projeto_id?: number | null;
    endereco?: string;
    unidade_consumidora: boolean;
    limitacao_observacao?: string;
    limitacao_projeto_id?: number | null;
    grupos_estruturas?: string;
}

export type VerticaisExtra = {
    valor?: number;
    valor_servico?: number;
    valor_servico_pis_cofins?: number;
    area_total?: number;
    peso_gerador?: number;
    peso_telhado?: number;
    potencia_gerador?: number;
    potencia_inversor?: number;
    estruturas?: GrupoEstrutura[];
}



export type Anexo = {
    id?: number | null;
    projeto_id?: number | null;
    url?: string | null;
    descricao?: string | null;
    created_at?: string | null;
    updated_at?: string | null;
    "@remove"?: boolean;
}

export type Disposicao = {
    grupo_estrutura_id?: number | null;
    "@remove"?: boolean;
    created_at?: string | null;
    updated_at?: string | null;
}

export type Desconto = {
    id?: number | null;
    tipo: string;
    percentual: string;
    "@remove"?: boolean;
    created_at?: string | null;
    updated_at?: string | null;
}

export type GrupoEstrutura = {
    id?: number | null;
    distribuicao?: boolean;
    nome: string;
    paisagem?: boolean;
    retrato?: boolean;
    updated_at?: string | null;
    created_at?: string | null;
    vertical?: boolean;
}

export type ComponenteProjeto = {
    componente_id: number
    modelo: string;
    quantidade: number;
    valor_unitario: number;
    valor_unitario_original: number;
}

export interface ServicoCalcular {
    tipo: ProjetoServico;
    valor: number;
    calculo_bdi?: boolean    
}

export interface ComponenteCalcular {
    quantidade: number;
    valor: number;
    categoria_componentes_id: number;
    peso: number;
    altura: number;
    largura: number;
    potencia: number;
}

export interface ProjetoCalcular {
    servicos: ServicoCalcular;
    componentes: ComponenteCalcular[];
}

type ProjetoServico = "revenda" | "intelbras" | null

export const DEFAULT_VERTICAIS: Verticais = {
    auto_comissao: true,
    cliente_proposta: "",
    codigo_venda: null,
    proposta_anexada: false,
    cpf_proposta: "",
    created_at: "",
    data_integracao: null,
    email_proposta: "",
    id: 0,
    potencia: 0,
    servico: null,
    situacao: "pedente",
    titulo: "",
    user_guilted_id: null,
    nota_fiscal_triangular: false,
    valor: 0,
    valor_servico: 0,
    valor_servico_pis_cofins: 0,
    observacao_sorps: "",
    ev: undefined,
    revenda: undefined,
    cidade: undefined,
    distribuidor: undefined,
    percentual_comissao_distribuidor: 0,
    percentual_comissao_revenda: 0,
    solicitacao: {
        unidade_consumidora: false,
    },
    justificativa_valor_servico: "",
}